import { Action, createReducer, on } from "@ngrx/store";
import { entityAdapter, initialState } from "./entity.state";
import { entityActions as entityActions } from "./entity.actions";

export const entityReducer = createReducer(
  initialState,
  on(entityActions.found, entityActions.netFound, entityActions.created, entityActions.netCreated, (state, { entity }) => {
    return entityAdapter.addOne(entity, state);
  }),
  on(entityActions.destroyed, entityActions.netDestroyed, (state, { id }) => {
    return entityAdapter.removeOne(id, state);
  }),
  on(entityActions.moved, entityActions.netMoved, (state, { entityId, oldPos, newPos }) => {
    return entityAdapter.updateOne(
        {
            id: entityId,
            changes: {
                coord: newPos,
            },
        },
        state,
    );
 }),
  on(entityActions.updated, entityActions.netUpdated, (state, { entity }) => {
    return entityAdapter.updateOne(
      {
        id: entity.id,
        changes: {
            ...entity
        },
      },
      state,
    );
  }),
    on(entityActions.updatedReactions, entityActions.netUpdatedReactions, (state, {entityId, newReactionProperties}) => {
        return entityAdapter.updateOne({
            id: entityId,
            changes: {
                componentProperties: {
                    ...state.entities[entityId].componentProperties,
                    Reactions: newReactionProperties
                }
            }
        }, state)
    })
);
